// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"kN-z","carouselContainer":"lN-z"};